export const DISPLAY_TEXT = 'display-text';
export const RISK_SETTINGS = 'settings';
export const FIELD_CONFIGURATION = 'field-configuration';
export const REGISTER_CONFIGURATION = 'register-configuration';
export const APPROVALS = 'approvals';
export const RISK_TYPE = 'risk-types';
export const RISK_CRITERIA = 'risk-criteria';
export const RISK_CATEGORY = 'risk-categories';
export const RISK_CALCULATION = 'risk-calculations';
export const RISK_TREATMENT = 'risk-treatment';
export const RISK_RATING_TYPE = 'rating-types';
export const RISK_REVIEW_FREQUENCY = 'review-frequency';
export const CUSTOM_LISTS = 'custom-lists';
export const RISK_CODE = 'risk-code';
export const RISK_CONSEQUENCE_TABLE = 'risk-consequence-table';
export const RISK_LIKELIHOOD = 'risk-likelihood';
export const BOW_TIE = 'bow-tie';
export const RISK_AGGREGATION = 'risk-aggregation';
export const RISK_APPETITE = 'risk-appetite';
export const STANDARD_ROLE = 'standard-role';
export const RISK_TEMPLATES = 'risk-templates';
export const HEATMAP_SETTINGS = 'heatmap-settings';
export const RISK_CRITERIA_GROUP = 'risk-criteria-group';
export const NOTIFICATION_TEMPLATES = 'notification-templates';
export const NOTIFICATION_RULES = 'notification-rules';
export const MULTIPLE_CONSEQUENCES = 'multiple-consequences';
